import { CountryType } from "types/Catalogs";
import "./styles.sass";
import InputSearch from "components/atoms/InputSearch";
import useTranslate from "hooks/useTranslate";

type CountrySelectProps = {
  countries: CountryType[] | null;
  onSelect: (country: string) => void;
};

const CountrySelect = (props: CountrySelectProps) => {
  const { countries, onSelect } = props;

  const t = useTranslate();

  return (
    <div className="CountrySelect">
      <div className="CountrySelect__search">
        <InputSearch
          name="country"
          placeholder={t("casino.countries.search")}
          value=""
        />
      </div>
      <div className="CountrySelect__list">
        {countries &&
          countries.length &&
          countries.map((country, index) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={index + country.code}
              className="CountrySelect__country"
              onClick={() => onSelect(country.code)}
            >
              <div className="CountrySelect__flag">
                <img
                  src={`https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/7.1.0/flags/1x1/${country.code.toLowerCase()}.svg`}
                  alt={country.name}
                />
              </div>
              <div className="CountrySelect__name">{country.name}</div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default CountrySelect;
